export default {
    dashboard: {
        groupExposure: 'Izloženost grupe',
        granularityBuckets: 'granularnost: {granularity} · intervali: {buckets}',
        refreshing: 'Osvježavanje…',
        loadingAggregate: 'Učitavanje agregata…',
        loadError: 'Nije moguće učitati agregat',
        noPositionData: 'Nema podataka o poziciji za {from} → {to}',
        noPositionDataHint: 'Zaključajte ugovore čija isporuka pada u ovaj raspon, zatim osvježite.',
        coverageShowing: 'Prikazuje se',
        coverageDaysFraction: '{days} od {requested} dana',
        coverageWithData: 's podacima',
        coverageRangeNote:
            'Odabrani raspon je {from} → {to}; dani bez zaključanih ugovora ili prognoze izostavljeni su iz vremenske osi ispod.',
        selectContract: 'Odaberite ugovor s lijeve strane za prikaz detalja',
    },
}
